import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/site/Navbar";
import HeroVideo from "@/components/site/HeroVideo";
import HowItWorks from "@/components/site/HowItWorks";
import ServiceRows from "@/components/site/ServiceRows";
import StatsBand from "@/components/site/StatsBand";
import HantavirusAlert from "@/components/site/HantavirusAlert";
import AudienceTabs from "@/components/site/AudienceTabs";
import PartnerNetwork from "@/components/site/PartnerNetwork";
import Testimonials from "@/components/site/Testimonials";
import LogoCloud from "@/components/site/LogoCloud";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import ScrollToHash from "@/components/site/ScrollToHash";
import ForDoctorsPage from "@/pages/ForDoctorsPage";
import ForHospitalsPage from "@/pages/ForHospitalsPage";
import HantavirusPage from "@/pages/HantavirusPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfUsePage from "@/pages/TermsOfUsePage";
import DataDeletionPage from "@/pages/DataDeletionPage";

const Landing = () => {
  return (
    <main data-testid="landing-page" className="bg-cream text-ink">
      <Navbar />
      <HeroVideo />
      <HowItWorks />
      <ServiceRows />
      <StatsBand />
      <HantavirusAlert />
      <AudienceTabs />
      <PartnerNetwork />
      <Testimonials />
      <LogoCloud />
      <FinalCTA />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/for-doctors" element={<ForDoctorsPage />} />
          <Route path="/for-hospitals" element={<ForHospitalsPage />} />
          <Route path="/hanta" element={<HantavirusPage />} />
          <Route path="/hantavirus" element={<HantavirusPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfUsePage />} />
          <Route path="/terms-of-use" element={<TermsOfUsePage />} />
          <Route path="/delete-account" element={<DataDeletionPage />} />
          <Route path="/data-deletion" element={<DataDeletionPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
